let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iyrSY")).then(() => parcelRequire('FRRBu'));